import { CommonStylesDefaultValuesWithTextPosition } from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { CommonStylesImageValues } from 'cms/cms-shared/common-settings-styles/image/common-settings-styles-image.models';
import { IdtComponentCmsDefinition, CmsComponentGroups } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';


export const PieceImageTextDefinition: IdtComponentDefinition = {
  id: 'piece-image-text',
  role: IdtComponentRole.Piece,
  numSlots: 0
};

export const PieceImageTextCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Imagen + Texto',
  group: CmsComponentGroups.Media,
  availablePlatforms: ['web', 'apps'],
  initialSettings: () => {
    return {
      general: {
        typetext: 'title',
        text: null,
        landscapeImage: {
          image: null,
          width: null,
          height: null
        },
        portraitImage: {
          image: null,
          width: null,
          height: null
        },
        title: '',
        alt: '',
        preloadImage: false,
        link: {
          type: null,
          category: null,
          product: null,
          src: null
        },
        marquee: {
          marqueeDurationDesktop: 20,
          marqueeDurationMobile: 5
        }
      },
      styles: {
        ...CommonStylesDefaultValuesWithTextPosition,
        ...CommonStylesImageValues
      }
    };
  }
};
